import { render } from "./ModifyIndex.vue?vue&type=template&id=07593d54&scoped=true"
import script from "./ModifyIndex.vue?vue&type=script&lang=js"
export * from "./ModifyIndex.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-07593d54"

export default script